module.exports = __webpack_public_path__ + "img/logo_dlp-white.3368aadf.svg";